import { defineComponent as _defineComponent } from 'vue'
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import {computed, ref} from "vue";
import {
  fetchPaymentTemplates,
} from "@/components/forms/payout/legacy/payment-templates";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {useRequest} from "vue-request"

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectPaymentTemplate',
  props: {
  system: {
    required: true,
    default: null
  },
  document: {
    required: false,
    default: null
  }
},
  emits: ['input', 'selected'],
  setup(__props, { expose, emit: emits }) {

const props = __props;






const system = computed(() => props.system);
const hasSystem = computed(() => {
  return system.value && (system.value.length > 0);
})


const templatesData = useRequest(() => fetchPaymentTemplates(system.value), {
  cacheKey: () => 'my-payment-templates-' + system.value,
  ready() {
    return hasSystem.value;
  },
  onAfter() {
    if (props.document) {
      selectTemplateByDocumentId(props.document);
    }
  },
  refreshDeps: [system]
})

const templatable = computed(() => {
  return templatesData.data?.value?.templatable || !templatesData.data?.value
      || !templatesData.loading?.value;
})
const templates = computed(() => {
  return templatesData.data?.value?.templates || [];
})

const loading = computed(() => {
  return hasSystem.value && templatesData.loading?.value;
})

const showBlock = computed(() => {
  return hasSystem.value && (templatable.value || templatesData.loading?.value);
})

const primeDropdownOptions = computed(() => {
  return templates.value || [];
})

const selectedTemplateId = ref(null);

const selectTemplateById = (id) => {
  const tpl = templates.value.find((template) => {
    return +template.id === +id;
  });
  if (tpl) {
    selectedTemplateId.value = +id;
    emits('selected', tpl);
    emits('input', tpl);
  } else {
    selectedTemplateId.value = null;
    emits('selected', null);
    emits('input', null);
  }
}

const selectTemplateByDocumentId = (id) => {
  const tpl = templates.value.find((template) => {
    return +template.documentId === +id;
  });
  // console.log('selectTemplateByDocumentId', tpl);
  if (tpl) {
    selectedTemplateId.value = +tpl.id;
    emits('selected', tpl);
    emits('input', tpl);
  } else {
    selectedTemplateId.value = null;
    emits('selected', null);
    emits('input', null);
  }
}

const clear = () => {
  selectTemplateById(null);
}

expose({
  clear
})

return { __sfc: true,props, emits, system, hasSystem, templatesData, templatable, templates, loading, showBlock, primeDropdownOptions, selectedTemplateId, selectTemplateById, selectTemplateByDocumentId, clear, PayoutFormGroup, PrimeDropdown }
}

})